require("../coord/parallel/parallelCreator");

require("./axis/parallelAxisAction");

require("./axis/ParallelAxisView");


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/parallelAxis.js
// module id = 782
// module chunks = 2